import React from "react";
import AllSubjectTopics from "../../../Topics/AllSubjectTopics";


function MindMapMathTopics() {
  return (
    <>

      <AllSubjectTopics subject="math" type="mindmap" />

    </>
  );
}

export default MindMapMathTopics;